import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { CustomerCalculatedSubscriptionStateEnum } from '@src/graphql/generated';
import './styles.scss';

const { TRIAL_ACTIVE, TRIAL_ENDED, SUBSCRIPTION_INACTIVE } = CustomerCalculatedSubscriptionStateEnum;

export default function LockedStatusMessage({ state, trialEndsAt }) {
  let message = null;

  switch (state) {
    case TRIAL_ACTIVE:
      const diffInDays = moment(trialEndsAt).diff(moment(), 'days');
      message = diffInDays === 0 ? 'Trial ends today.' : `${diffInDays + 1} days trial remaining.`;
      break;
    case TRIAL_ENDED:
      message = 'Trial has ended.';
      break;
    case SUBSCRIPTION_INACTIVE:
      message = 'Subscription is not active.';
      break;
  }

  return <span className="locked-status-message">{message}</span>;
}

LockedStatusMessage.propTypes = {
  state: PropTypes.string.isRequired,
  trialEndsAt: PropTypes.string.isRequired,
};
